// Display label the old naming fallback stamped on a chat after three failed
// attempts. Nothing writes it any more; rows that already carry it are treated
// as unnamed so they get a real title the next time naming runs.
const PLACEHOLDER_CHAT_TITLE = "Untitled";

// True when a chat's title carries no information and the chat still needs a
// name. Blank titles reach us from several directions — a chat that was never
// named is null, saveChatThread coerces null to "" on the way to Cosmos and it
// comes back as "", and process-setup creates chats with "" when it has no
// title to give them. Never decide "this chat is already named" from the title
// merely being non-null: that is what made the "Untitled" label permanent and
// what left every unnamed chat reloaded from Cosmos stuck without a name.
export const isUnnamedChatTitle = (title: string | null | undefined): boolean =>
  title == null || title.trim() === "" || title === PLACEHOLDER_CHAT_TITLE;
